import { Box, Dialog, Grid } from 'src/components';
import DialogContent from 'src/components/DialogContent';
import DialogTitle from 'src/components/DialogTitle';
import { useAppSelector } from 'src/store';
import { translate } from 'src/i18n/tHelper';
import HastalikForm from './HastalikForm';
import HastalikTaniForm from './HastalikTaniForm';
import HastalikTaniIslemEkle from './HastalikTaniIslemEkle';
import { useEffect, useState } from 'react';

interface IHastalikDialogProps {
    onClose?: () => void
 };
const path = 'pages|hataliktanim';
const HastalikDialog = (props: IHastalikDialogProps): JSX.Element => {
    const dialogParam = useAppSelector(s=> s.hastalikTanim.dialogParam);

    return(
        <Dialog open={dialogParam > 0}>
            <DialogTitle>
                {
                    dialogParam === 1 ? translate(path, 'Hastalık Tanımı') 
                    : dialogParam === 2 ? translate(path, 'Hastalık Tanı Tanım')
                    : dialogParam === 3 ? translate(path, 'Hastalık Tanı İşlem Ekle')
                    : null
                }
            </DialogTitle>
            <DialogContent  >
                <Box sx={{paddingTop:1}}>
                    {
                        dialogParam === 1 ? <HastalikForm />
                        : dialogParam === 2 ? <HastalikTaniForm />
                        : dialogParam === 3 ? <HastalikTaniIslemEkle />
                        : null
                    }
                </Box>
            </DialogContent>
        </Dialog>
    )
};

export default HastalikDialog;